import { Link } from "react-router-dom";
import { Crown } from "lucide-react";

export default function PaymentCancel() {
  return (
    <div className="max-w-xl mx-auto px-6 sm:px-8 pt-20 pb-24 text-center" data-testid="payment-cancel-page">
      <Crown className="w-9 h-9 text-[#B7AE9F] mx-auto" strokeWidth={1.5} />
      <h1 className="font-heading text-2xl sm:text-3xl text-[#2C2A29] mt-6">Checkout canceled</h1>
      <p className="font-body text-sm text-[#7A756E] mt-2">No charge was made. Premium is here whenever you're ready.</p>
      <Link to="/premium" data-testid="payment-cancel-back"
        className="inline-block mt-8 px-8 py-3.5 bg-[#2C2A29] text-[#FAF9F6] rounded-sm hover:opacity-90 transition-opacity duration-300">
        See Premium plans
      </Link>
    </div>
  );
}
